// removed by extract-text-webpack-plugin
module.exports = {"iconDefault":"_3wG7agYbgq84bo7byOxj_o"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/src/Icons/dist/Icon.scss
// module id = ./node_modules/wix-style-react/src/Icons/dist/Icon.scss
// module chunks = 0